var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_2",
    "data-name": "Artboard \\u2013 2",
    clipPath: "url(#clip-Artboard_2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TV",
    d: "M16.763,4.043a.8.8,0,0,0-.735-.343q-5.851.006-11.7,0c-.049,0-.095,0-.144,0a.8.8,0,0,0-.746.816v8.8a.79.79,0,0,0,.6.79,3.539,3.539,0,0,0,.563.03c.141,0,.281,0,.44,0-.039.071-.06.123-.088.168-.176.332-.359.66-.531.991a.457.457,0,0,0,.222.663.412.412,0,0,0,.521-.231q.4-.738.791-1.48a.188.188,0,0,1,.193-.116q4.025.006,8.054,0a.176.176,0,0,1,.183.112q.39.749.8,1.491a.408.408,0,0,0,.584.194.46.46,0,0,0,.148-.637c-.165-.317-.338-.63-.506-.943-.035-.063-.067-.127-.109-.209.288,0,.559.007.83,0a.781.781,0,0,0,.721-.514c.021-.048.039-.1.056-.153V4.382A1.624,1.624,0,0,0,16.763,4.043Zm-.7,9.191H4.291V4.6H16.066Z",
    transform: "translate(0.323 2.155)",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.72d92ec23f302bfa4cccff9c99389746.svg";
export { ForwardRef as ReactComponent };